"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WHITESMOKE = exports.SPANISHGREY = exports.SILVERTREE = exports.MUSTARD = exports.LILAC = exports.JET = exports.GHOSTWHITE = exports.CHETWODEBLUE = exports.CHARCOAL = exports.BORDER = exports.BLACKPEARL = exports.BITTERSWEET = void 0;
var SILVERTREE = "#4AD384";
exports.SILVERTREE = SILVERTREE;
var CHETWODEBLUE = "#687FE2";
exports.CHETWODEBLUE = CHETWODEBLUE;
var BITTERSWEET = "#FD6C6C";
exports.BITTERSWEET = BITTERSWEET;
var JET = "#303030";
exports.JET = JET;
var CHARCOAL = "#2F3C4E";
exports.CHARCOAL = CHARCOAL;
var WHITESMOKE = "#F4F4F4";
exports.WHITESMOKE = WHITESMOKE;
var BLACKPEARL = "#00141F";
exports.BLACKPEARL = BLACKPEARL;
var SPANISHGREY = "#909090";
exports.SPANISHGREY = SPANISHGREY;
var GHOSTWHITE = "#F6F7FB";
exports.GHOSTWHITE = GHOSTWHITE;
var LILAC = "#EBF0FC";
exports.LILAC = LILAC;
var BORDER = "#D5D9ED";
exports.BORDER = BORDER;
var MUSTARD = "#FDD34F";
exports.MUSTARD = MUSTARD;